import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/serviceManage/index',
    name: 'serviceManageIndex',
    component: () => import('@/sub-app/serviceManage/pages/index.vue'),
    meta: {
      title: '',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
